import Component from '../abstracts/Component';

export default class MiniWishlistComponent extends Component {
  get SELECTORS() {
    return {
      miniWishlistButton: '[data-mini-wishlist-button]',
      headerWishlistIcon: '[data-mini-wishlist-button-icon]',
      miniWishlistLayer: '[data-mini-wishlist-layer]',
      miniWishlistLayerWrapper: '[data-mini-wishlist-layer-wrapper]',
      miniWishlistContainer: '[data-mini-wishlist-container]',
      miniWishlistCloseButton: '[data-close-mini-wishlist-layer]',
      miniWishlistContent: '[data-mini-wishlist-content]',

      // HTML data attributes for mini wishlist product elements
      miniWishlistItemsWrapper: '[data-mini-wishlist-items-wrapper]',

      miniWishlistCountIncoming: '[data-mini-wishlist-quantity-update]',
      miniWishlistProductElement: '[data-mini-wishlist-product]',

      miniWishlistProductRemove: 'data-mini-wishlist-product-remove',
      miniWishlistProductRemoveAction:
        'data-remove-product-from-mini-wishlist-action',
      miniWishlistProductRemoveCode: 'data-product-code',
      miniWishlistProductRemoveBaseCode: 'data-product-base-code',

      miniWishlistProductAddToCart: 'data-mini-wishlist-product-add-to-cart',
      miniWishlistProductUniqueSize: 'data-product-is-unique-size',
      miniWishlistProductHasSizeSelected: 'data-product-has-size-selected',
      miniWishlistProductAddToCartAction:
        'data-add-product-from-mini-wishlist-action',

      miniWishlistProductSizeSelector:
        '[data-mini-wishlist-product-size-selector]',
      miniWishlistProductSizeSelectorId:
        'data-mini-wishlist-product-size-selector-id',
      miniWishlistProductSizeSelectorTargetId:
        'data-mini-wishlist-product-size-selector-target-id',

      miniWishlistProductSizeSelectorClose:
        'data-mini-wishlist-product-size-selector-close',
      miniWishlistProductSizeSelectorButton:
        'data-mini-wishlist-product-size-button',
      miniWishlistProductSizeSelectorButtonAction:
        'data-add-product-size-from-mini-wishlist-action',
    };
  }

  get CLASSES() {
    return {
      miniWishlistCommonOpenClass: '--open',
      miniWishlistShowClass: 'show', // Used for XGen mutation observers
      miniWishlistHiddenClass: '--hidden',
      miniWishlistPerformingActionClass: '--performing-action',
      miniWishlistOpenLayerClass: '--open-layer',

      miniWishlistOpenClassAfterAdd: '--open-quick',
      miniWishlistOpenLayerClassAfterAdd: '--open-layer-quick',
    };
  }

  get CONSTANTS() {
    return {
      WISHLIST_QUICK_NOTIFICATION_TIMEOUT: 2500,
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.currentViewport = null;
    this.timeOutQuickShow = null;

    this.dom = {
      miniWishlistButton: this.$component.querySelector(
        this.SELECTORS.miniWishlistButton
      ),
      headerWishlistIcon: this.$component.querySelector(
        this.SELECTORS.headerWishlistIcon
      ),
      miniWishlistCloseButton: this.$component.querySelector(
        this.SELECTORS.miniWishlistCloseButton
      ),
      miniWishlistLayer: this.$component.querySelector(
        this.SELECTORS.miniWishlistLayer
      ),
      miniWishlistLayerWrapper: this.$component.querySelector(
        this.SELECTORS.miniWishlistLayerWrapper
      ),
      miniWishlistContainer: document.querySelector(
        this.SELECTORS.miniWishlistContainer
      ),
      miniWishlistContent: this.$component.querySelector(
        this.SELECTORS.miniWishlistContent
      ),
      miniWishlistContentNotify: this.$component.querySelector(
        this.SELECTORS.miniWishlistContentNotify
      ),
      headerElement: document.querySelector('header.c-main-header'),
    };
  }

  /**
   * This function is called before show the mini cart layer in order to calculate the max height
   * based on the current height of the header, to prevent hiding the layer when it's greaten
   * than the viewport.
   */
  updateMiniWishlistMaxHeight() {
    if (
      this.dom.miniWishlistLayerWrapper &&
      this.dom.headerElement &&
      this.currentViewport !== 'mobile'
    ) {
      this.dom.miniWishlistLayerWrapper.style.maxHeight = `calc(100dvh - ${this.dom.headerElement.offsetHeight}px)`;
    }
  }

  /**
   * Iterate through all mini wishlist product size selector layers,
   * and toggle the open class for the layer that matches the target id.
   *
   * @param {Object} [options] - Options for the function.
   * @param {String} [options.target] - The id of the layer to toggle the open class for.
   * @param {Boolean} [options.open] - Whether to add or remove the open class.
   */
  iterateAllMiniWishlistProductSizeSelectorLayers({
    target = null,
    open = false,
  } = {}) {
    const getAllSizeSelectorLayers =
      this.dom.miniWishlistContent.querySelectorAll(
        this.SELECTORS.miniWishlistProductSizeSelector
      );
    getAllSizeSelectorLayers.forEach((currentSelectorLayer) => {
      const currentSelectorLayerId = currentSelectorLayer.getAttribute(
        this.SELECTORS.miniWishlistProductSizeSelectorId
      );
      if (
        open &&
        !!target &&
        currentSelectorLayerId &&
        currentSelectorLayerId === target
      ) {
        if (
          !currentSelectorLayer.classList.contains(
            this.CLASSES.miniWishlistCommonOpenClass
          )
        )
          currentSelectorLayer.classList.add(
            this.CLASSES.miniWishlistCommonOpenClass
          );
      } else {
        if (
          currentSelectorLayer.classList.contains(
            this.CLASSES.miniWishlistCommonOpenClass
          )
        )
          currentSelectorLayer.classList.remove(
            this.CLASSES.miniWishlistCommonOpenClass
          );
      }
    });
  }

  /**
   * Perform a mini wishlist action on the server side, such as
   * adding a product to the wishlist or removing it.
   * @param {string} miniWishlistProductAction - The URL of the action to perform.
   * @param {boolean} [emitUpdateCart=false] - If true, emit an 'update'
   *   event on the minicart component after the action has been performed.
   * @returns {Promise<void>}
   */

  async performMiniWishlistAction({
    miniWishlistProductAction,
    productCode = undefined,
    baseProductCode = undefined,
    emitUpdateCart = false,
  }) {
    const url = miniWishlistProductAction;
    this.iterateAllMiniWishlistProductSizeSelectorLayers();
    this.dom.miniWishlistContent.classList.add(
      this.CLASSES.miniWishlistPerformingActionClass
    );
    await fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response?.status === 200) {
          this.updateMiniWishlist();
          if (emitUpdateCart) {
            this.$emit(this.$customEvents.MINICART_EVENTS.update, {
              quickNotify: true,
            });
          }
          if (productCode && baseProductCode)
            this.$emit(this.$customEvents.MINIWISHLIST_EVENTS.removed, {
              productCode,
              baseProductCode,
            });
        } else {
          console.error('Error performing mini wishlist action');
          this.dom.miniWishlistContent.classList.remove(
            this.CLASSES.miniWishlistPerformingActionClass
          );
        }
      })
      .catch((error) => {
        console.error(error);
        this.dom.miniWishlistContent.classList.remove(
          this.CLASSES.miniWishlistPerformingActionClass
        );
      });
  }

  /**
   * Handle mini wishlist item click event
   * @param {Event} event - DOM event
   * @returns {undefined}
   */
  handleMiniWishlistItemClick(event) {
    event.preventDefault();

    const currentTarget = event.target;
    /**
     * Target is the "Remove from wishlist" button, perform the add to cart action
     */
    if (currentTarget.getAttribute(this.SELECTORS.miniWishlistProductRemove)) {
      const deleteAction = currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductRemoveAction
      );
      const productCode = currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductRemoveCode
      );
      const baseProductCode = currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductRemoveBaseCode
      );
      if (deleteAction && !!productCode && !!baseProductCode)
        this.performMiniWishlistAction({
          miniWishlistProductAction: deleteAction,
          productCode,
          baseProductCode,
        });
      return;
    }
    /**
     * Target is the "Add to cart from wishlist" button
     */
    if (
      currentTarget.getAttribute(this.SELECTORS.miniWishlistProductAddToCart)
    ) {
      const productIsUniqueSize = currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductUniqueSize
      );
      const productHasSizeSelected = currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductHasSizeSelected
      );
      /**
       * If product is unique size or has a size selected, perform the add to cart action
       */
      if (
        `${productIsUniqueSize}` === 'true' ||
        (`${productIsUniqueSize}` === 'false' &&
          `${productHasSizeSelected}` === 'true')
      ) {
        const addToCartAction = currentTarget.getAttribute(
          this.SELECTORS.miniWishlistProductAddToCartAction
        );
        if (addToCartAction)
          this.performMiniWishlistAction({
            miniWishlistProductAction: addToCartAction,
            emitUpdateCart: true,
          });
      } else {
        /**
         * Product is not unique size, and no sizes was selected
         * get all size selectors layers add the open class to
         * the size selector layer for the product and remove it
         * from the others.
         */
        const currentItemSizeSelectorTarget = currentTarget.getAttribute(
          this.SELECTORS.miniWishlistProductSizeSelectorTargetId
        );
        this.iterateAllMiniWishlistProductSizeSelectorLayers({
          target: currentItemSizeSelectorTarget,
          open: true,
        });
      }
      return;
    }
    /**
     * Target is the "Close size selector layer" button
     */
    if (
      currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductSizeSelectorClose
      )
    ) {
      const currentItemSizeSelectorTarget = currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductSizeSelectorTargetId
      );
      this.iterateAllMiniWishlistProductSizeSelectorLayers({
        target: currentItemSizeSelectorTarget,
      });
      return;
    }
    /**
     * Target is one of the "Add to cart by size from wishlist" button
     */
    if (
      currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductSizeSelectorButton
      )
    ) {
      const addToCartAction = currentTarget.getAttribute(
        this.SELECTORS.miniWishlistProductSizeSelectorButtonAction
      );
      if (addToCartAction)
        this.performMiniWishlistAction({
          miniWishlistProductAction: addToCartAction,
          emitUpdateCart: true,
        });
      return;
    }
  }

  cancelQuickWishlistNotification() {
    this.dom.miniWishlistLayer.classList.remove(
      this.CLASSES.miniWishlistOpenClassAfterAdd,
      this.CLASSES.miniWishlistShowClass
    );
    this.dom.miniWishlistContainer.classList.remove(
      this.CLASSES.miniWishlistOpenLayerClassAfterAdd
    );
  }

  openQuickWishlistNotification() {
    if (this.currentViewport !== 'mobile') {
      this.dom.miniWishlistLayer.classList.add(
        this.CLASSES.miniWishlistOpenClassAfterAdd,
        this.CLASSES.miniWishlistShowClass
      );
      this.updateMiniWishlistMaxHeight();
      this.dom.miniWishlistContainer.classList.add(
        this.CLASSES.miniWishlistOpenLayerClassAfterAdd
      );
      this.timeOutQuickShow = setTimeout(() => {
        this.cancelQuickWishlistNotification();
      }, this.CONSTANTS.WISHLIST_QUICK_NOTIFICATION_TIMEOUT);
    }
  }

  async updateMiniWishlist() {
    const url = this.dom.miniWishlistButton.dataset.urlMiniWishlist;
    if (
      !this.dom.miniWishlistContent.classList.contains(
        this.CLASSES.miniWishlistPerformingActionClass
      )
    )
      this.dom.miniWishlistContent.classList.add(
        this.CLASSES.miniWishlistPerformingActionClass
      );
    /**
     * Refresh the current mini wishlist by getting the HTML content from fetch request
     */
    await fetch(url)
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        try {
          /**
           * Check the current mini wishlist HTML in order to identify all products
           * and delete the click events listeners in order to prevent memory leaks
           * and performance issues
           */
          const currentMiniWishlistProduct =
            this.dom.miniWishlistContent.querySelectorAll(
              this.SELECTORS.miniWishlistProductElement
            );
          if (currentMiniWishlistProduct.length > 0)
            currentMiniWishlistProduct.forEach((currentProduct) => {
              currentProduct.removeEventListener('click', (event) =>
                this.handleMiniWishlistItemClick(event.target)
              );
            });
          /**
           * Convert the new response as HTML
           */
          const htmlResponseMiniWishlist = new DOMParser().parseFromString(
            text,
            'text/html'
          );
          /**
           * Identify all product elements in the response and add a event
           * listener to identify all use cases
           */
          const newMiniWishlistProduct =
            htmlResponseMiniWishlist.body.querySelectorAll(
              this.SELECTORS.miniWishlistProductElement
            );

          if (newMiniWishlistProduct.length > 0)
            newMiniWishlistProduct.forEach((currentProduct) => {
              currentProduct.addEventListener('click', (event) => {
                this.handleMiniWishlistItemClick(event);
              });
            });
          /**
           * Retrieve the current mini wishlist quantity,
           */
          const wishlistCurrentQuantity =
            htmlResponseMiniWishlist.body.querySelector(
              this.SELECTORS.miniWishlistCountIncoming
            ).innerHTML || null;
          /**
           * Clean the current mini wishlist HTML content and append the new content
           */
          this.dom.miniWishlistContent.innerHTML = '';
          while (htmlResponseMiniWishlist.body.firstChild) {
            this.dom.miniWishlistContent.append(
              htmlResponseMiniWishlist.body.firstChild
            );
          }
          if (wishlistCurrentQuantity > 0) {
            this.dom.headerWishlistIcon.classList.add('icon-wishlist-on');
            this.dom.headerWishlistIcon.classList.remove('icon-wishlist-off');
          } else {
            this.dom.headerWishlistIcon.classList.remove('icon-wishlist-on');
            this.dom.headerWishlistIcon.classList.add('icon-wishlist-off');
          }
        } catch (error) {
          console.error('Error parsing result while updating the wishlist.');
          console.error(error);
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        this.dom.miniWishlistContent.classList.remove(
          this.CLASSES.miniWishlistPerformingActionClass
        );
      });
  }

  closeMiniWishlist() {
    if (
      this.dom.miniWishlistLayer.classList.contains(
        this.CLASSES.miniWishlistCommonOpenClass
      )
    ) {
      this.dom.miniWishlistLayer.classList.remove(
        this.CLASSES.miniWishlistCommonOpenClass
      );
      this.dom.miniWishlistContainer.classList.remove(
        this.CLASSES.miniWishlistOpenLayerClass,
        this.CLASSES.miniWishlistShowClass
      );
      this.iterateAllMiniWishlistProductSizeSelectorLayers();
      if (this.currentViewport === 'mobile') {
        this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
      }
    }
  }

  handleWishlistButtonClick(event) {
    clearTimeout(this.timeOutQuickShow);
    this.cancelQuickWishlistNotification();
    if (this.currentViewport === 'tablet') {
      event.preventDefault();
      if (
        this.dom.miniWishlistLayer.classList.contains(
          this.CLASSES.miniWishlistCommonOpenClass
        )
      ) {
        this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
        this.closeMiniWishlist();
      } else {
        this.$emit(this.$customEvents.BACKDROP_EVENTS.show, {
          disableGlobalOverflow: true,
        });
        this.$emit(this.$customEvents.MINIWISHLIST_EVENTS.open);
        const miniWishlistItemsWrapper =
          this.dom.miniWishlistLayer.querySelector(
            this.SELECTORS.miniWishlistItemsWrapper
          );
        this.dom.miniWishlistContent.scrollTop = 0;
        this.dom.miniWishlistLayerWrapper.scrollTop = 0;
        this.updateMiniWishlistMaxHeight();
        if (miniWishlistItemsWrapper) miniWishlistItemsWrapper.scrollTop = 0;
        this.dom.miniWishlistLayer.classList.add(
          this.CLASSES.miniWishlistCommonOpenClass
        );
        /**
         * Hide benefit bar, navigation menu and search layer
         */
        this.$emit(this.$customEvents.MENU_EVENTS.hideMenu, {
          fromMiniWishlist: true,
          showBenefitBar: this.currentViewport === 'tablet',
        });
        this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.hide);
        this.$emit(this.$customEvents.MINICART_EVENTS.close);
        if (this.currentViewport === 'mobile') {
          this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.hide);
        }
        this.dom.miniWishlistContainer.classList.add(
          this.CLASSES.miniWishlistOpenLayerClass,
          this.CLASSES.miniWishlistShowClass
        );
      }
    }
  }

  calculateCurrentViewport() {
    const viewportWidth = window.innerWidth;
    let currentViewport = 'mobile';
    if (viewportWidth >= 768 && viewportWidth < 1440) {
      currentViewport = 'tablet';
    } else if (viewportWidth >= 1440) {
      currentViewport = 'desktop';
    }

    return currentViewport;
  }

  bindEvents() {
    // Detect the current viewport
    this.currentViewport = this.calculateCurrentViewport();
    window.addEventListener('resize', () => {
      const newViewport = this.calculateCurrentViewport();
      if (this.currentViewport !== newViewport) {
        if (newViewport === 'mobile') {
          clearTimeout(this.timeOutQuickShow);
          this.cancelQuickWishlistNotification();
        }
        if (
          this.dom.miniWishlistLayer.classList.contains(
            this.CLASSES.miniWishlistCommonOpenClass
          )
        ) {
          if (newViewport === 'mobile')
            this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.hide);
          else {
            this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
            if (newViewport === 'desktop') {
              this.dom.miniWishlistLayer.classList.remove(
                this.CLASSES.miniWishlistCommonOpenClass
              );
            }
          }
        }
      }
      this.currentViewport = newViewport;
    });

    // On item added to wishlist, show quick wishlist notification and update mini wishlist
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, () => {
      this.updateMiniWishlist().then(() => {
        this.openQuickWishlistNotification();
      });
    });

    // On item removed to wishlist, update mini wishlist
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, () =>
      this.updateMiniWishlist()
    );

    // Bind the mini cart button mouseenter to calculate the max height of the minicart layout
    this.dom.miniWishlistButton.addEventListener('click', (event) =>
      this.handleWishlistButtonClick(event)
    );

    // Bind the mini wishlist button to open the mini-wishlist layout
    this.dom.miniWishlistButton.addEventListener('mouseenter', (event) =>
      this.updateMiniWishlistMaxHeight(event)
    );

    // Bind the mini wishlist button when mouse enter in desktop
    this.dom.miniWishlistContainer.addEventListener('mouseenter', () => {
      if (this.currentViewport === 'desktop') {
        clearTimeout(this.timeOutQuickShow);
        this.cancelQuickWishlistNotification();
        const miniWishlistItemsWrapper =
          this.dom.miniWishlistLayer.querySelector(
            this.SELECTORS.miniWishlistItemsWrapper
          );
        if (miniWishlistItemsWrapper) miniWishlistItemsWrapper.scrollTop = 0;
        this.dom.miniWishlistLayerWrapper.scrollTop = 0;
        this.dom.miniWishlistContainer.classList.add(
          this.CLASSES.miniWishlistShowClass
        );
      }
    });

    // Bind the mini wishlist button when mouse leave in desktop
    this.dom.miniWishlistContainer.addEventListener('mouseleave', () => {
      if (this.currentViewport === 'desktop') {
        this.iterateAllMiniWishlistProductSizeSelectorLayers();
        this.dom.miniWishlistContainer.classList.remove(
          this.CLASSES.miniWishlistShowClass
        );
      }
    });

    // Bind the mini wishlist close button to close the mini-wishlist layout
    this.dom.miniWishlistCloseButton.addEventListener('click', () => {
      this.$emit(this.$customEvents.BENEFIT_BAR_EVENTS.show);
      this.$emit(this.$customEvents.BACKDROP_EVENTS.hide);
      this.dom.miniWishlistLayer.classList.remove(
        this.CLASSES.miniWishlistCommonOpenClass
      );
      this.dom.miniWishlistContainer.classList.remove(
        this.CLASSES.miniWishlistOpenLayerClass,
        this.CLASSES.miniWishlistShowClass
      );
    });

    // Listen to backdrop close event
    this.$on(this.$customEvents.BACKDROP_EVENTS.close, () => {
      this.closeMiniWishlist();
    });

    // Listen to mini wishlist close, if current layout is not desktop
    this.$on(this.$customEvents.MINIWISHLIST_EVENTS.close, () => {
      if (this.currentViewport !== 'desktop') this.closeMiniWishlist();
    });

    // Listen to mini wishlist update event
    this.$on(this.$customEvents.MINIWISHLIST_EVENTS.update, () => {
      this.updateMiniWishlist();
    });
  }

  render() {
    this.log('Rendering...');
    // on page load retrieve the mini wishlist content
    this.updateMiniWishlist().then(() => {
      this.bindEvents();
    });
  }
}
